module.exports = __webpack_public_path__ + "static/media/shekel-sign.eadd9970.svg";